import React, { useState, useEffect, useCallback, useLayoutEffect } from 'react'
// eslint-disable-next-line import/no-extraneous-dependencies
import { MdFilterList, MdDelete, MdKeyboardArrowDown } from 'react-icons/md'
import { useDispatch, useSelector } from 'react-redux'
import classnames from 'classnames'
import useWalletFilters from './useWalletFilters'
import * as reducks from '../../../reducks'
import ModalOrder from './ModalOrder/ModalOrder'
import ModalPeople from './ModalPeople/ModalPeople'
import ModalFilters from './ModalFilters/ModalFilters'
import Text from '../Text/Text'
import Flex from '../Flex/Flex'
import Tag from '../Tag/Tag'
import TagSelect from '../TagSelect/TagSelect'
import * as filtersLib from '../../../lib/filters'
import styles from './filters.module.scss'

export const VALID_PEOPLE_FILTERS = [
  'networkCodes',
  'subsidiaryCodes',
  'partnerStdCodes'
]

export const VALID_FILTERS = [
  'priorityMatrices',
  'storeStatus',
  'segments',
  'storeGroups',
  'products'
]

export const handleResetFilters = (dispatch) => {
  dispatch(reducks.resources.wallet.actions.walletClearAllFilter())
}

const Filters = () => {
  const dispatch = useDispatch()

  const {
    canViewPartner,
    canViewNetwork,
    canViewSubsidiary,
    canViewGroup,
    canViewProduct,
    canViewStatus,
    canGetSegmentsAndSubsegments,
    canViewPriorityMatrices,
    filters
  } = useWalletFilters()

  const canViewButtonPeopleFilters =
    canViewNetwork || canViewPartner || canViewSubsidiary

  const canViewButtonFilters =
    canViewGroup || canViewProduct || canViewStatus || canViewPriorityMatrices

  const hasPeopleFilters = filtersLib.activeFilters(
    VALID_PEOPLE_FILTERS,
    filters
  )
  const hasFilters = filtersLib.activeFilters(VALID_FILTERS, filters)

  const [showPeopleFilter, setShowPeopleFilter] = useState(false)
  const [showFilters, setShowFilters] = useState(false)
  const [showOrderFilter, setShowOrderFilter] = useState(false)

  const [textOrderBy, setTextOrderBy] = useState('Ordenar')

  const subSegmentsReducer = useSelector(
    (state) => state.filtersReducer.subsegments
  )

  useEffect(() => {
    if (canGetSegmentsAndSubsegments) {
      dispatch(reducks.resources.filters.actions.getSubSegments())
    }
  }, [canGetSegmentsAndSubsegments])

  useEffect(() => {
    switch (filters.orderBy) {
      case 'production':
        {
          const text =
            filters.orderByDirection === 'asc'
              ? 'Ordenado Produção ↑'
              : 'Ordenado Produção ↓'
          setTextOrderBy(text)
        }
        break
      case 'name_fantasy':
        {
          const text =
            filters.orderByDirection === 'asc'
              ? 'Ordenado Nome A-Z'
              : 'Ordenado Nome Z-A'
          setTextOrderBy(text)
        }
        break
      default:
        setTextOrderBy('Ordenar')
        break
    }
  }, [filters])

  const handleShowModalPeopleFilters = useCallback(() => {
    setShowPeopleFilter(true)
  }, [])

  const handleHideModalPeopleFilters = useCallback(() => {
    setShowPeopleFilter(false)
  }, [])

  const handleShowModalFilters = useCallback(() => {
    setShowFilters(true)
  }, [])

  const handleHideModalFilters = useCallback(() => {
    setShowFilters(false)
  }, [])

  const handleShowModalOrder = useCallback(() => {
    setShowOrderFilter(true)
  }, [])

  const handleHideModalOrder = useCallback(() => {
    setShowOrderFilter(false)
  }, [])

  const [scrollPosition, setScrollPosition] = useState(false)

  const getPositionYContainerWalletFilters = (e) => {
    if (e.target.scrollTop > 150) {
      setScrollPosition(true)
    } else {
      setScrollPosition(false)
    }
  }

  useLayoutEffect(() => {
    const [mainContainer] = document.getElementsByTagName('main')
    mainContainer.addEventListener('scroll', getPositionYContainerWalletFilters)
    return () =>
      mainContainer.removeEventListener(
        'scroll',
        getPositionYContainerWalletFilters
      )
  }, [])

  const containerStyles = classnames(styles.tagContainer, {
    [styles.tagContainerFixed]: scrollPosition
  })

  return (
    <div className={containerStyles}>
      <ModalOrder
        filters={filters}
        closeCallback={handleHideModalOrder}
        visible={showOrderFilter}
      />

      <ModalFilters
        filters={filters}
        visible={showFilters}
        closeCallback={handleHideModalFilters}
      />

      <ModalPeople
        filters={filters}
        visible={showPeopleFilter}
        closeCallback={handleHideModalPeopleFilters}
      />

      <Flex
        justifyContent="flex-start"
        width="100%"
        alignItems="center"
        wrap="wrap"
      >
        <Tag
          white
          text={textOrderBy}
          active={filters.orderBy}
          Icon={() => (
            <MdKeyboardArrowDown
              color={filters.orderBy ? 'white' : '#4D4D4D'}
            />
          )}
          onClick={handleShowModalOrder}
        />

        {subSegmentsReducer.content.length > 0 && (
          <TagSelect
            placeholder="Sub-segmento"
            options={subSegmentsReducer.content.asMutable().map((item) => ({
              value: item.id,
              name: item.name
            }))}
            value={filters.subsegments}
            onChange={async (subsegments) => {
              await dispatch(
                reducks.resources.wallet.actions.walletApplyFilters({
                  subsegments: [subsegments]
                })
              )
            }}
          />
        )}

        {canViewButtonPeopleFilters && (
          <Tag
            white
            width="114px"
            text="Pessoas"
            active={hasPeopleFilters}
            Icon={() => (
              <MdFilterList color={hasPeopleFilters ? 'white' : '#737373'} />
            )}
            onClick={handleShowModalPeopleFilters}
          />
        )}

        {canViewButtonFilters && (
          <Tag
            white
            width="114px"
            text="Filtros"
            active={hasFilters}
            Icon={() => (
              <MdFilterList color={hasFilters ? 'white' : '#737373'} />
            )}
            onClick={handleShowModalFilters}
          />
        )}

        <div>
          <button
            type="button"
            className={styles.buttonText}
            onClick={() => handleResetFilters(dispatch)}
          >
            <Text
              value="Limpar"
              color="gray"
              variation="dark"
              size="xs"
              font="custom"
            />
            <MdDelete color="#4D4D4D" />
          </button>
        </div>
      </Flex>
    </div>
  )
}

export default Filters
